import React from "react";
import Playground from "src/components/playground/playground";
import PlaygroundLayout from "src/components/playground/playground-layout";
import { useEffect } from "react";
import { useModelViewerStore } from "@/store/modelViewerStore";

const PlaygroundPage: React.FC = () => {
  return (
    <PlaygroundLayout
      children={<Playground />}
    ></PlaygroundLayout>
  );
};

export default PlaygroundPage;
